// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"48":"laboratory","353":"contact","417":"setting","431":"getmoney","857":"report","899":"payment","962":"home","964":"product"}[chunkId] + "." + {"48":"20eaa860","353":"dca76e56","417":"8fe7c76f","431":"b2b7a874","857":"d89794c3","899":"53623755","962":"5b885f96","964":"d9d6a7fc"}[chunkId] + ".css";
};